import React, { FC } from "react";
import { Box, Grid, InputLabel } from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../model/styles";

const FormLabelValueField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const inputRender = (isInGrid: boolean) => {
    return (
      <Box
        component="section"
        sx={{
          p: 1,
          border: "1px solid #DBDBDB",
          borderRadius: "5px",
          height: props?.heightVal ? props?.heightVal : "calc(100% - 18px)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textWrap: "wrap",
          // marginTop: props?.marginTopVal || ''
        }}
      >
        {props?.value}
      </Box>
    );
  };
  return (
    <>
      {props?.label ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? 1.5 : 5}
            className={classes.labelBox}
            sx={{ marginTop: props?.isNonMarginTop ? "0px !important" : "", ...props?.InputProps?.sx }}
          >
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {props?.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              padding: "0px",
              // marginTop: props?.marginTopVal || '',
            }}
          >
            {inputRender(true)}
          </Grid>
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormLabelValueField;
